import "./App.scss";
import { Route, Routes, useLocation, useNavigate } from "react-router";
import Home from "./pages/home/Home";
import Projects from "./pages/projects/Projects";
import Navbar from "./components/navbar/Navbar";
import PageTransition from "./components/page_transition/PageTransition";
import Contact from "./pages/contact/Contact";
import ProjectsIndiv from "./pages/projects_indiv/ProjectsIndiv";
import Footer from "./components/footer/Footer";
import MobileNavbar from "./components/mobile_navbar/MobileNavbar";
import { IoCallSharp } from "react-icons/io5";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { ToastContainer, toast, Bounce } from "react-toastify";
import NotFound from "./pages/not_found/NotFound";

gsap.registerPlugin(ScrollTrigger);
function App() {
  const btnRef = useRef(null);
  const location = useLocation();
  const footerRef = useRef(null);
  const navbarRef = useRef();
  const mobileRef = useRef();
  const navigate = useNavigate();
  const [formResult, setFormResult] = useState("");

  useEffect(() => {
    if (formResult === "Form Submitted Successfully") {
      toast.success("Form Submitted Successfully", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
        transition: Bounce,
      });
    }

    if (formResult === "Error") {
      toast.error("❌ Something went wrong!", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
        transition: Bounce,
      });
    }
  }, [formResult]);

  useLayoutEffect(() => {
    if (!btnRef.current) return;

    if (location.pathname === "/contact") {
      gsap.set(btnRef.current, { opacity: 0, y: 20 });
      ScrollTrigger.getAll().forEach((t) => t.kill());
      return;
    }

    ScrollTrigger.getAll().forEach((t) => t.kill());

    gsap.set(btnRef.current, { opacity: 0, y: 20 });

    const show = gsap.to(btnRef.current, {
      opacity: 1,
      y: 0,
      duration: 0.4,
      paused: true,
    });

    // SHOW after scroll
    ScrollTrigger.create({
      trigger: document.body,
      start: "top+=200 top",
      onEnter: () => show.play(),
      onLeaveBack: () => show.reverse(),
    });

    // HIDE when footer enters viewport
    ScrollTrigger.create({
      trigger: footerRef.current,
      start: "top bottom", // when footer touches bottom of screen
      onEnter: () => show.reverse(),
      onLeaveBack: () => show.play(),
    });

    ScrollTrigger.refresh();
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname !== "/") {
      if (window.innerWidth < 768) {
        gsap.to(mobileRef.current, {
          opacity: 1,
          duration: 0.2,
          ease: "power2.inOut",
        });
      }
      if (window.innerWidth >= 768) {
        gsap.to(navbarRef.current, {
          opacity: 1,
          duration: 0.2,
          ease: "power2.inOut",
        });
      }
    }
  }, []);

  return (
    <div className="app_main">
      {
        <div className="call_button_main" ref={btnRef}>
          <a href="tel:+918056166287" style={{ textDecoration: "none" }}>
            <h2 onClick={() => {}}>
              <IoCallSharp />
              Call us
            </h2>
          </a>
        </div>
      }
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        className={"toast_container"}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
      <PageTransition>
        {window.innerWidth < 768 && <MobileNavbar mobileRef={mobileRef} />}
        {window.innerWidth >= 768 && <Navbar navbarRef={navbarRef} />}
        <Routes>
          <Route
            path="/"
            element={<Home navbarRef={navbarRef} mobileRef={mobileRef} />}
          />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:id" element={<ProjectsIndiv />} />
          <Route
            path="/contact"
            element={<Contact result={formResult} setResult={setFormResult} />}
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </PageTransition>
      <Footer ref={footerRef} />
    </div>
  );
}

export default App;
